import React from 'react';
import { Route } from 'react-router-dom';
import { goLogin } from '../../utils/common-functions';

const LoginRedirect = () => {
    return (
        <Route
            render={() => {
                goLogin();
                return null;
            }}
        />
    );
};

export default LoginRedirect;



// WEBPACK FOOTER //
// ./src/components/commons/login-redirect.js